// extracted by mini-css-extract-plugin
var _1 = "src-pages-configurable-dashboard-components-palette-item-__layout--fxtqk9Wg9ePkieMFBAZ1";
export { _1 as "layout" }
